import React from 'react'
import { useNavigate } from "react-router-dom";
import './ResourceSelector.css';


function ResourceSelector() {
    const navigate = useNavigate();

  return (
    <div className="resource-container">
      <button className="resource-button" onClick={() => navigate("/printable-activities")}>
        Printable Activities
      </button>
      <button className="resource-button" onClick={() => navigate("/planning-tools")}>
        Planning Tools
      </button>
      <button className="resource-button" onClick={() => navigate("/training")}>
        Training and <br /> In-services
      </button>
    </div>
  );
}

export default ResourceSelector